module.exports = {"nav":{"langChange":"Canvia de llengua","lang":"Llengua","translate":"Tradueix"}};